import "./ChecklistList.scss"
import { Column } from "devextreme-react/data-grid"
import { t } from "i18next"
import ChecklistsApi from "../api/ChecklistApi"
import { useNavigate } from "react-router-dom"
import { PagedList } from "../../../core/api/pagedList"
import { useRef } from "react"
import { ActionBar, DateTimeLocal, GenericDataGrid, GenericDataGridRef, IconButtonDelete, IconButtonEdit, Row } from "../../../core/components"

export default function Checklists() {
    const gridRef = useRef<GenericDataGridRef>(null);

    const navigate = useNavigate()

    const addChecklist = () => {
        navigate(`/checklists/new`)
    }

    const handleEdit = (id: string) => {
        navigate(`/checklists/${id}`)
    }

    const fetchData = async (odataQueryParameters?: string): Promise<PagedList<object>> => {
        return await ChecklistsApi.getChecklists(false, odataQueryParameters)
    }

    const deleteChecklist = async (idChecklist: number): Promise<void> => {
        if (await ChecklistsApi.deleteChecklist(idChecklist)) {
            gridRef.current?.reload()
        }
    }

    return (
    <>
        <ActionBar buttons={[
            {
                text: t("Add"),
                icon: "plus",
                stylingMode: "contained",
                type: "default",
                onClick: addChecklist
            }
        ]} />

        <GenericDataGrid
            id="ChecklistsList"
            ref={gridRef}
            className={"card m-05 checklists-list-height"}
            rowKey={"idChecklist"}
            fetchData={fetchData}
            handleAddNew={addChecklist}
            handleEdit={handleEdit} >
            <Column
                dataField={"code"}
                caption={t("Code")}
                allowFiltering={false}
                allowHiding={false}
                minWidth={200} />
            <Column
                dataField={"name"}
                caption={t("Name")}
                allowFiltering={false}
                allowHiding={false}
                minWidth={200} />
            <Column
                dataField={"description"}
                caption={t("Description")}
                allowFiltering={false}
                allowSorting={false}
                minWidth={300} />
            <Column
                dataField={"revisionDate"}
                caption={t("Revision Date")}
                dataType={"date"}
                allowFiltering={false}
                minWidth={240}
                cellRender={data => <DateTimeLocal dateTimeUtc={data.data.revisionDate} />} />
            <Column
                fixed
                caption={t("Actions")}
                width={100}
                fixedPosition="right"
                cellRender={(cellInfo) => (
                    <Row>
                        <IconButtonEdit
                            size="small"
                            tooltip={t("Edit")}
                            onClick={() => handleEdit(cellInfo.data.idChecklist)} />
                        <IconButtonDelete
                            size="small"
                            tooltip={t("Delete")}
                            onClick={() => {deleteChecklist(cellInfo.data.idChecklist)}} />
                    </Row>)} />
        </GenericDataGrid>
    </>
    )
}
